<template>
  <modern-pie-chart
    v-if="dataLoaded"
    :title="title"
    :series="series"
    :labels="labels"
    :colors="chartColors"
    :height="300"
    :show-donut="false"
    :show-data-labels="true"
    :show-legend="true"
    :display-mode="displayMode"
  />
  <div v-else class="loading-message">
    <p>Carregando...</p>
  </div>
</template>

<script>
import { companyStatusChart } from "@/api/charts";
import { getStatusText, getStatusColor } from "@/views/complaints/utils";
import ModernPieChart from "./ModernPieChart.vue";
import { displayModeMixin } from "./displayModeMixin";

export default {
  name: "StatusChart",
  mixins: [displayModeMixin],
  components: {
    ModernPieChart,
  },
  props: {
    company: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      series: [],
      labels: [],
      chartColors: [],
      dataLoaded: false,
    };
  },

  async created() {
    try {
      const response = await companyStatusChart(this.company, this.type);
      const data = response.data;

      // Validar se os dados existem e são um array
      if (!data || !Array.isArray(data) || data.length === 0) {
        this.series = [];
        this.labels = [];
        this.chartColors = [];
        return;
      }

      for (const item of data) {
        if (!item || typeof item.count === "undefined") {
          continue; // Pular itens inválidos
        }

        const statusText = getStatusText(item._id);
        const statusColor = getStatusColor(item._id);

        if (statusText && statusColor) {
          this.labels.push(statusText);
          this.series.push(item.count || 0);
          this.chartColors.push(statusColor);
        }
      }

      this.dataLoaded = true;
    } catch (error) {
      this.series = [];
      this.labels = [];
      this.chartColors = [];
      this.dataLoaded = true;
    }
  },
};
</script>
<style scoped>
.loading-message {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  color: #94a3b8;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  font-size: 14px;
}
</style>
